import type { RomanApiError } from "@roman/shared/lib/net/romanApi";
import romanApi from "@roman/shared/lib/net/romanApi";
import type { SWRMutationConfiguration } from "swr/mutation";
import useSWRMutation from "swr/mutation";

type TelegramLoginRequest = {
  token: string;
};

type LoginWithTelegramResponse = {
  isFirstTime: boolean;
  accessToken: string;
};

const fetcher = (url: string, args: { arg: TelegramLoginRequest }) =>
  romanApi.post<LoginWithTelegramResponse, TelegramLoginRequest>(url, args.arg, { withCredentials: true });

export const useLoginWithTelegram = (
  options?: SWRMutationConfiguration<LoginWithTelegramResponse, RomanApiError, string, TelegramLoginRequest>,
) => {
  const { data, trigger } = useSWRMutation(
    "/oauth/telegram/login",
    (url: string, args: { arg: TelegramLoginRequest }) => fetcher(url, args),
    options,
  );
  return {
    data,
    trigger,
  };
};
